module.exports = __webpack_public_path__ + "static/media/confident_purchases.3253dadc.png";